var _path, _path2, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgArrorLinkBlack2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.5729 9C17.5729 13.6925 13.7529 17.5 9.03644 17.5C4.31999 17.5 0.5 13.6925 0.5 9C0.5 4.30748 4.31999 0.5 9.03644 0.5C13.7529 0.5 17.5729 4.30748 17.5729 9Z",
    fill: "white",
    stroke: "#231A3D"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2_16699",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 4,
    width: 10,
    height: 10
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.20052 9.56276H11.5091L8.75297 12.3078C8.53271 12.5271 8.53271 12.8871 8.75297 13.1065C8.97323 13.3259 9.32904 13.3259 9.5493 13.1065L13.2712 9.39964C13.4915 9.18026 13.4915 8.82589 13.2712 8.60651L9.55495 4.89402C9.44943 4.78869 9.30618 4.72949 9.15678 4.72949C9.00739 4.72949 8.86413 4.78869 8.75862 4.89402C8.53835 5.11339 8.53835 5.46777 8.75862 5.68714L11.5091 8.43776H5.20052C4.88989 8.43776 4.63574 8.69089 4.63574 9.00026C4.63574 9.30964 4.88989 9.56276 5.20052 9.56276Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2_16699)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 2.25879,
    y: 2.25,
    width: 13.5547,
    height: 13.5,
    fill: "#231A3D"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrorLinkBlack2);
export default __webpack_public_path__ + "static/media/arrorLinkBlack2.120d2d67e0e50f24cb02a2323b52da24.svg";
export { ForwardRef as ReactComponent };